export const FETCH_ALL_PROJECTS_SUCCEEDED = 'FETCH_ALL_PROJECTS_SUCCEEDED'
export const FETCH_ALL_PROJECTS_REQUESTED = 'FETCH_ALL_PROJECTS_REQUESTED'
export const FETCH_ALL_PROJECTS_FAILED = 'FETCH_ALL_PROJECTS_FAILED'
export const UPDATE_FILTERS = 'UPDATE_FILTERS'
export const UPDATE_IS_LOADING = 'UPDATE_IS_LOADING'
export const FETCH_PROJECTS_LIST_SUCCEEDED = 'FETCH_PROJECTS_LIST_SUCCEEDED'
export const FETCH_PROJECTS_LIST_REQUESTED = 'FETCH_PROJECTS_LIST_REQUESTED'